module.exports = __webpack_public_path__ + "img/home-apply.af4dabd9.png";